export { Tooltip } from './Tooltip';
export type { ITooltipProps } from './types';
